import styled from 'styled-components'
import { getDotsContainerStyles } from '../style'

const StyledDotsContainer = styled.div(getDotsContainerStyles)

export default StyledDotsContainer
